
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 145 144","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M65.572 144C29.416 144 0 114.786 0 78.88c0-32.97 25.826-61.577 58.795-65.128l1.246-.128V4.171C60.041.383 62.143 0 67.3 0h.578c19.665 0 39.313 7.974 53.891 21.876C136.75 36.156 145.001 54.887 145 74.62c0 13.187-3.72 23.282-6.842 29.428-1.3 2.556-2.55 2.889-3.497 2.889a5.357 5.357 0 01-1.727-.332l-6.976-2.404-.521 1.162C114.899 128.835 91.401 144 65.572 144zm-39.7-21.582l1.14.975a59.371 59.371 0 0038.561 14.206c22.981 0 45.296-14.152 53.068-33.648l.535-1.345-54.443-18.829-38.86 38.641zM58.448 20.175C29.287 24.355 6.446 50.14 6.446 78.88a58.503 58.503 0 0013.915 37.835l.98 1.15 38.703-38.48V19.946l-1.597.229zm8.038-13.77v71.18l64.632 21.854.57-1.005c4.395-7.767 6.357-15.109 6.357-23.805 0-36.343-32.642-68.223-69.854-68.223l-1.704-.001z","fill":"#fff"}})])
          )
        }
      }
    